import { format, parseISO } from 'date-fns';
import { nl } from 'date-fns/locale';

export default function dateFormat(date) {
  return format(parseISO(date), 'd LLL yyy', { locale: nl });
}
